import type { UUID } from '@cobliteam/common-types';
import type { TriggerRule } from './rules';

enum ConditionCategory {
  // Geofence
  GEOFENCE_IN = 'GEOFENCE_IN',
  GEOFENCE_OUT = 'GEOFENCE_OUT',
  GEOFENCE_IN_OUT = 'GEOFENCE_IN_OUT',

  // Geofence speed limit
  GEOFENCE_SPEED = 'GEOFENCE_SPEED',

  // Idle engine
  IDLE_ENGINE_3_MINUTES = 'IDLE_ENGINE_3_MINUTES',
  IDLE_ENGINE_5_MINUTES = 'IDLE_ENGINE_5_MINUTES',
  IDLE_ENGINE_10_MINUTES = 'IDLE_ENGINE_10_MINUTES',
  IDLE_ENGINE_15_MINUTES = 'IDLE_ENGINE_15_MINUTES',
  IDLE_ENGINE_30_MINUTES = 'IDLE_ENGINE_30_MINUTES',

  // Device health status - observation period
  DEVICE_HEALTH_STATUS_OBSERVATION_PERIOD_NORMAL = 'DEVICE_HEALTH_STATUS_OBSERVATION_PERIOD_NORMAL',
  DEVICE_HEALTH_STATUS_OBSERVATION_PERIOD_UNAVAILABLE = 'DEVICE_HEALTH_STATUS_OBSERVATION_PERIOD_UNAVAILABLE',
  DEVICE_HEALTH_STATUS_OBSERVATION_PERIOD_NORMAL_UNAVAILABLE = 'DEVICE_HEALTH_STATUS_OBSERVATION_PERIOD_NORMAL_UNAVAILABLE',

  // Device connection
  DEVICE_CONNECTION_CONNECTED = 'DEVICE_CONNECTION_CONNECTED',
  DEVICE_CONNECTION_DISCONNECTED = 'DEVICE_CONNECTION_DISCONNECTED',
  DEVICE_CONNECTION_CONNECTED_DISCONNECTED = 'DEVICE_CONNECTION_CONNECTED_DISCONNECTED',

  // Vehicle speed limit
  VEHICLE_SPEED_LIMIT_30_SECONDS = 'VEHICLE_SPEED_LIMIT_30_SECONDS',
  VEHICLE_SPEED_LIMIT_1_MINUTE = 'VEHICLE_SPEED_LIMIT_1_MINUTE',
  VEHICLE_SPEED_LIMIT_5_MINUTES = 'VEHICLE_SPEED_LIMIT_5_MINUTES',
  VEHICLE_SPEED_LIMIT_10_MINUTES = 'VEHICLE_SPEED_LIMIT_10_MINUTES',

  // Road speed limit
  ROAD_SPEED_LIMIT_30_SECONDS = 'ROAD_SPEED_LIMIT_30_SECONDS',
  ROAD_SPEED_LIMIT_1_MINUTE = 'ROAD_SPEED_LIMIT_1_MINUTE',
  ROAD_SPEED_LIMIT_5_MINUTES = 'ROAD_SPEED_LIMIT_5_MINUTES',
  ROAD_SPEED_LIMIT_10_MINUTES = 'ROAD_SPEED_LIMIT_10_MINUTES',

  // Driver identification
  DRIVER_IDENTIFICATION_WITHOUT_DRIVER = 'DRIVER_IDENTIFICATION_WITHOUT_DRIVER',

  // Checklist
  CHECKLIST_UNFILLED = 'CHECKLIST_UNFILLED',

  // Cameras Health
  DRIVER_CAMERA_OBSTRUCTED_OR_UNOBSTRUCTED = 'DRIVER_CAMERA_OBSTRUCTED_OR_UNOBSTRUCTED',
  DRIVER_CAMERA_OBSTRUCTED = 'DRIVER_CAMERA_OBSTRUCTED',
  DRIVER_CAMERA_UNOBSTRUCTED = 'DRIVER_CAMERA_UNOBSTRUCTED',

  // Dangerous / distracted driving
  RISK_EVENT = 'RISK_EVENT',
  CAUSED_BY = 'CAUSED_BY',
}

enum ConditionParam {
  GEOFENCE = 'GEOFENCE',
  DAY_OF_WEEK = 'DAY_OF_WEEK',
  TIME = 'TIME',
  VEHICLE_GROUP = 'VEHICLE_GROUP',
  VEHICLE = 'VEHICLE',
  ROAD_SPEED_SEVERITY = 'ROAD_SPEED_SEVERITY',
  MAXIMUM_SPEED = 'MAXIMUM_SPEED',
}

interface Condition {
  id: UUID;
  name: string;
  category: ConditionCategory;
  params: ConditionParam[];
  cameraRequired?: boolean;
}

// Lista de triggers
interface TriggerCondition {
  id: UUID;
  name: string;
  category: ConditionCategory;
  params: ConditionParam[];
  rule: TriggerRule;
}

export type { Condition, TriggerCondition };
export { ConditionCategory, ConditionParam };
